module.exports = __webpack_public_path__ + "static/media/iot2.906f8113.avif";